import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import { validateUsername } from './validation/username';

export const checkUsernameAvailability = async (db, usernameLower, currentUid) => {
  const validation = validateUsername(usernameLower);
  if (!validation.ok) {
    return { status: 'invalid' };
  }

  const mappingSnap = await getDoc(doc(db, 'usernames', usernameLower));
  if (mappingSnap.exists()) {
    const data = mappingSnap.data() || {};
    if (data.uid === currentUid) {
      return { status: 'reservedByYou' };
    }
    return { status: 'taken', takenByUid: data.uid };
  }

  const usersRef = collection(db, 'users');
  const byLower = await getDocs(query(usersRef, where('usernameLower', '==', usernameLower), limit(1)));
  if (!byLower.empty) {
    const docSnap = byLower.docs[0];
    if (docSnap.id === currentUid) {
      return { status: 'reservedByYou' };
    }
    return { status: 'taken', takenByUid: docSnap.id };
  }

  const byUsername = await getDocs(query(usersRef, where('username', '==', usernameLower), limit(1)));
  if (!byUsername.empty) {
    const docSnap = byUsername.docs[0];
    if (docSnap.id === currentUid) {
      return { status: 'reservedByYou' };
    }
    return { status: 'taken', takenByUid: docSnap.id };
  }

  return { status: 'available' };
};
